/** @jsx isolateComponent */

import { FlexLayout } from '@zapier/common-components';
import { isolateComponent } from '@zapier/common-utils';
import { Button, Icon, Spacer, Text } from '@zapier/design-system';

import { useSize } from '@zapier/promotions/src/hooks';

type Props = {
  body: string;
  onClose: () => void;
  title: string;
};

export const OfferErrorView = ({ body, title, onClose }: Props) => {
  const size = useSize();

  return (
    <FlexLayout align="center" direction="column" wrap="no-wrap">
      <Icon name="alertCircle" size={60} />

      <Text tag="h1" type="header700">
        {title}
      </Text>

      <Text tag="p" textAlign="center" type="bodyText900">
        {body}
        <br />
        Need help? Please contact support.
      </Text>

      <Spacer height={20} />

      <FlexLayout
        direction={size === 'small' ? 'column' : 'row'}
        justify="center"
      >
        <Button color="greyAlt" href="/help" isFullWidth={size === 'small'}>
          Contact support
        </Button>

        <Button
          hasShadow={true}
          isFullWidth={size === 'small'}
          onClick={onClose}
        >
          Close
        </Button>
      </FlexLayout>
    </FlexLayout>
  );
};
